
import {WOW} from '../../../node_modules/wowjs/dist/wow';
new WOW().init();
// import AOS from 'aos';               
// import '../styles/aos.css';

// AOS.init({
//   disable: false,
//   duration: 500,
//   offset: 30,
//   easing: 'ease-in-out-sine'
// });
// new WOW({
//   offset: 100
// }).init();


$('.form-item.select input').on('click',function(){
  let $parent = $(this).closest('.select')
  
  if(!$parent.hasClass('hover')){
    $('.form-item.select').removeClass('hover')
    $parent.addClass('hover')
  }else{
    $parent.removeClass('hover')
  }
})

$('.form-item.select ul li').on('click',function(){
  let that = $(this)
  let val = $(this).html()
  that.closest('.select').find('input').val(val)
  that.closest('.select').removeClass('hover')
  
  setTimeout(function(){
    that.addClass('on').siblings().removeClass('on')
  },200)
})

$('body').on('click',function(e){
  if($(e.target).parents('.form-item.select').length == 0){
    $('.form-item.select').removeClass('hover')
  }
})

$('.form-facebook .close-btn').on('click',function(){
  $('.form-facebook').removeClass('active')
})